<script setup>
import { ref } from 'vue';
import { RepositoryFactory } from '@/data/repositoryFactory.js';
import { handleResponseWithMessages } from '../../helpers/wwwHelper';
import RepoFilesTablePOST from '@/components/fileRepositories/RepoFilesTablePOST.vue';
import TransportRepoFilesFilterAndSearchPanel from './TransportRepoFilesFilterAndSearchPanel.vue';
import { useAuthStore } from '../../stores/auth';
import { ACCESS_TRANSPORT_ORDER_DELETE_FILES } from '../../data/constants/authConstants';

const RepositoryFiles = RepositoryFactory.get('files');
const props = defineProps({
  orderId: { type: Number, required: true },
  modalImageContainerId: { type: String, required: true },
  urlOverride: { type: String, required: false, default: null },
  longerSearchBar: { type: Boolean, default: false }
});
const transportKey = ref(0);
const searchBox = ref('');
const userFilter = ref(null);
const transportRepoFilesFilterAndSearchPanel = ref();
const authStore = useAuthStore();

function onFetchDataWithFiltersRequest({ search, filter }) {
  searchBox.value = search;
  userFilter.value = filter;
  transportKey.value++;
}

async function deleteTransportResource(resourceId) {
  var response = await RepositoryFiles.deleteTransportResource(resourceId);

  handleResponseWithMessages(response, 'Plik został usunięty.', () => {
    transportKey.value++;
  });
}
</script>

<template>
  <TransportRepoFilesFilterAndSearchPanel
    ref="transportRepoFilesFilterAndSearchPanel"
    :longerSearchBar="props.longerSearchBar"
    @fetchData="onFetchDataWithFiltersRequest"
  />

  <RepoFilesTablePOST
    :key="transportKey"
    :modalId="props.modalImageContainerId"
    :url="props.urlOverride ?? `order/${props.orderId}/transportFiles`"
    :showBorder="false"
    :longerSearchBar="props.longerSearchBar"
    :deletingEnabled="authStore.canAccess(ACCESS_TRANSPORT_ORDER_DELETE_FILES)"
    :searchFromOutside="searchBox"
    :userFilter="userFilter"
    :deleteFunctionOverride="deleteTransportResource"
    @dataFetched="transportRepoFilesFilterAndSearchPanel?.updateAppliedFilters"
  />
</template>

<style scoped></style>
